import { format, isToday, isYesterday } from 'date-fns';

/**
 * Normalize non-ISO date string to ISO with UTC
 */
const normalizeDateString = (str: string): string => {
  const trimmed = str.trim();
  if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(trimmed)) {
    return trimmed.replace(' ', 'T') + 'Z';
  }

  return trimmed;
};

/**
 * Formats a date string or Date object to a user-friendly string using local time
 */

const formatDate = (date: Date | string | null | undefined): string => {
  try {
    if (!date) return 'Date unavailable';

    let asDate: Date;
    let time: string | null = null;

    if (date instanceof Date) {
      asDate = date;
    } else if (typeof date === 'string') {
      // Handle basic YYYY-MM-DD format
      if (/^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT/.test(date)) {
        asDate = new Date(Date.parse(date));
      }
      // Assume it's ISO-like and normalize
      else {
        const normalized = normalizeDateString(date);
        asDate = new Date(normalized);
      }

      // Format time if valid
      if (!isNaN(asDate.getTime())) {
        time = format(asDate, 'h:mm a');
      }
    } else {
      return 'Invalid date format';
    }

    if (isNaN(asDate.getTime())) {
      return 'Invalid date';
    }
    //transform time
    if (isToday(asDate)) {
      return `Today, ${time}`;
    } else if (isYesterday(asDate)) {
      return `Yesterday, ${time}`;
    } else {
      return format(asDate, 'MMM dd, yyyy');
    }
  } catch (error) {
    console.error('Error formatting date:', date, error);
    return 'Date error';
  }
};

/**
 * Formats a date string or Date object to a time-only string (e.g., "11:45 AM") using local time
 */
const formatTime = (date: Date | string | null | undefined): string => {
  try {
    if (!date) return '';

    let asDate: Date;

    if (date instanceof Date) {
      asDate = date;
    } else if (typeof date === 'string') {
      if (/^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT/.test(date)) {
        asDate = new Date(Date.parse(date));
      } else {
        const normalized = normalizeDateString(date);
        asDate = new Date(normalized);
      }
    } else {
      return '';
    }

    if (isNaN(asDate.getTime())) {
      return '';
    }

    return format(asDate, 'h:mm a');
  } catch (error) {
    console.error('Error formatting time:', date, error);
    return '';
  }
};

export { formatDate, formatTime };
